import { shade } from 'polished';
import styled, { css } from 'styled-components';

interface ContainerProps {
  color: string;
}

export const Container = styled.button<ContainerProps>`
  height: 45px;
  border-radius: 10px;
  border: 0;
  padding: 0 12px;
  color: #fff;
  font-weight: 500;
  margin-top: 20px;
  transition: background-color 0.2s;

  ${(props) =>
    css`
      background: ${props.color};

      &:hover {
        background: ${shade(0.2, props.color)};
      }
    `}

  ${(props) =>
    props.disabled &&
    css`
      background: #28262e;

      &:hover {
        background: #28262e;
      }
    `}
`;
